import * as svg from "../../../assets/checked-circle-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CheckedSolidCircleIcon = iconBuilder(svg, "CheckedSolidCircleIcon", "0 0 16 16");
